import { Button, ButtonProps, cn } from "@tellescope/ui";
import { ArrowUpDown, Filter } from "lucide-react";

export interface ConfigureTableViewButtonProps extends Omit<ButtonProps, "children" | "variant" | "size"> {
  hasFilter: boolean;
  hasSorting: boolean;
  filterCount?: number;
}

export const ConfigureTableViewButton = ({
  hasFilter,
  hasSorting,
  filterCount,
  className,
  ...rest
}: ConfigureTableViewButtonProps) => {
  const iconCount = hasSorting ? 2 : 1;

  return (
    <Button
      {...rest}
      variant="outline"
      size="icon"
      className={cn("relative px-2 transition-all flex gap-3", iconCount === 1 ? "w-9" : "w-[64px]", className)}
    >
      {hasFilter && filterCount ? (
        <span className="absolute -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-primary text-[10px] text-primary-foreground">
          {filterCount}
        </span>
      ) : null}
      <div className="relative">
        <Filter />
        {hasFilter && !filterCount && <div className="absolute -top-1.5 -right-1.5 h-2 w-2 rounded-full bg-primary" />}
      </div>
      {hasSorting && (
        <div className="relative">
          <ArrowUpDown />
          <div className="absolute -top-1.5 -right-1.5 h-2 w-2 rounded-full bg-primary" />
        </div>
      )}
    </Button>
  );
};
